import HTTPClient from '@/common/http-client';
import { InductionListResponse } from '@/common/model/response/induction-list-response.model';
import { LinkInductionRequest } from '../model/request/link-induction-request.model';
import { LinkInductionResponse } from '@/common/model/response/link-induction-response.model';
import { MstDeviceType } from '@/common/enum/mst-device-type.enum';
import { ScanMode } from '@/common/enum/scan-mode.enum';

import { ScanModeGetResponse, ScanModePutRequest, ScanModePutResponse } from '@/common/model/scan-mode.model';
import BaseService from './base.service';
import { GetLinkInductionResponse } from '../../tsort/model/response/get-link-induction-response.model';
import { CheckDeviceLinkedWithInductionResponse } from '@/model/response/check-device-linked-with-induction-response.model';
import AppConstants from '../constants/app.constants';
export default class SettingService extends BaseService {
  private INDUCTION_SETTING_GET_INDUCTION_URL = `/func/get-induction`;
  private LINK_INDUCTION_DEVICE_URL = AppConstants.LINK_INDUCTION_DEVICE_URL;
  private CREATE_DEVICE_URL = `/func/create-device`;
  private SETTING_GET_SCAN_MODE_URL = `/func/scan-mode`;
  private SETTING_PUT_SCAN_MODE_URL = `/func/scan-mode`;
  private GET_LINK_INDUCTION = `/func/get-link-induction`;

  public async getInductions(): Promise<InductionListResponse> {
    const getInductionAxiosResponse = await this.HTTP.get<InductionListResponse>(
      this.INDUCTION_SETTING_GET_INDUCTION_URL
    );
    const getInductionResponse = HTTPClient.convertAxiosResponseToResponse(getInductionAxiosResponse);
    return getInductionResponse;
  }

  public async getLinkInduction(
    externalDeviceId: string,
    externalDeviceType: number
  ): Promise<GetLinkInductionResponse> {
    const getLinkInductionAxiosResponse = await this.HTTP_WITHOUT_MSG.get<GetLinkInductionResponse>(
      this.GET_LINK_INDUCTION,
      {
        params: {
          externalDeviceId,
          externalDeviceType
        }
      }
    );
    const getLinkInductionResponse = HTTPClient.convertAxiosResponseToResponse(getLinkInductionAxiosResponse);
    return getLinkInductionResponse;
  }

  public async postLinkInductionDevice(
    linkInductionDeviceRequest: LinkInductionRequest
  ): Promise<LinkInductionResponse> {
    // call API to create Device if it does not exist then link it with Induction
    const linkInductionDeviceAxiosResponse = await this.HTTP.post<LinkInductionResponse>(
      this.LINK_INDUCTION_DEVICE_URL,
      linkInductionDeviceRequest
    );
    const linkInductionDeviceResponse = HTTPClient.convertAxiosResponseToResponse(linkInductionDeviceAxiosResponse);
    return linkInductionDeviceResponse;
  }

  public async getScanMode(): Promise<ScanModeGetResponse> {
    const scanModeAxiosResponse = await this.HTTP.get<ScanModeGetResponse>(this.SETTING_GET_SCAN_MODE_URL);
    const scanModeResponse = HTTPClient.convertAxiosResponseToResponse(scanModeAxiosResponse);
    return scanModeResponse;
  }

  public async putScanMode(scanMode: ScanMode): Promise<ScanModePutResponse> {
    const scanModeRequest: ScanModePutRequest = { scanMode };
    const scanModePutAxiosResponse = await this.HTTP.put<ScanModePutResponse>(
      this.SETTING_PUT_SCAN_MODE_URL,
      scanModeRequest
    );
    const scanModePutResponse = HTTPClient.convertAxiosResponseToResponse(scanModePutAxiosResponse);
    return scanModePutResponse;
  }

  public async postBluetoothAddress(externalDeviceId: string, bluetoothAddress: string): Promise<void> {
    await this.HTTP.post<void>(this.CREATE_DEVICE_URL, {
      mstDevice: [
        { externalDeviceId, type: MstDeviceType.HT },
        { bluetoothAddress, type: MstDeviceType.PRINTER }
      ]
    });
  }

  public async checkDeviceLinkedWithInduction(
    req: LinkInductionRequest
  ): Promise<CheckDeviceLinkedWithInductionResponse> {
    const res = await this.HTTP.get<CheckDeviceLinkedWithInductionResponse>(this.LINK_INDUCTION_DEVICE_URL, {
      params: {
        inductionId: req.inductionId,
        externalDeviceId: req.externalDeviceId,
        type: req.type
      }
    });
    const result = HTTPClient.convertAxiosResponseToResponse(res);
    return result;
  }
}
